
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

import { FormModel } from 'ant-design-vue';

@Component({})
export default class CAROrderRemarkModal extends Vue {
  type!: 'COrder' | 'BOrder';

  orderNo = '';

  title = '';

  labelCol = { span: 1 };

  wrapperCol = { span: 16 };

  isVisible = false;

  isLoading = false;

  form = {
    remark: '',
  };

  get isDisabled() {
    if (!this.form.remark || this.form.remark === '') {
      return true;
    }
    return false;
  }

  @Ref() readonly ruleForm!: FormModel;

  @lazyInject(CarService)
  carService!: CarService;

  open(param: {
    type: 'BOrder' | 'COrder';
    orderNo: string;
    title: string;
    text: string;
  }) {
    const { type, orderNo, title, text } = param;
    this.type = type;
    this.orderNo = `${orderNo}`;
    this.title = title;
    this.form.remark = text;

    this.isVisible = true;
  }

  close() {
    if (this.isLoading) {
      setTimeout(() => {
        this.$emit('close');
        this.reset();
      }, 300);
      return;
    }
    this.reset();
  }

  async submit() {
    const data = {
      order_no: this.orderNo,
      remark: this.form.remark,
    };
    const res = await this.carService.postShopOrderAppendRemark(data);
    if (res) {
      this.$message.success(`${res}`);
      this.$emit('refresh');
      this.reset();
    }
  }

  reset() {
    this.isVisible = false;
    this.isLoading = false;
    this.title = '';
    this.orderNo = '';

    this.form = {
      remark: '',
    };
  }
}
